import axios from "../../config/axiosConfig";
import {
  PRODUCTION_REGISTER_GRAY_REPORT_REQUEST,
  PRODUCTION_REGISTER_GRAY_REPORT_SUCCESS,
  PRODUCTION_REGISTER_GRAY_REPORT_FAILURE,
  PRODUCTION_REGISTER_GRAY_FILTER_REPORT_REQUEST,
  PRODUCTION_REGISTER_GRAY_FILTER_REPORT_SUCCESS,
  PRODUCTION_REGISTER_GRAY_FILTER_REPORT_FAILURE
} from "../types/production-register-gray-report-types";

export const getProductionRegisterGrayReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REGISTER_GRAY_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/production-register-report/gray?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_REGISTER_GRAY_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: PRODUCTION_REGISTER_GRAY_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: PRODUCTION_REGISTER_GRAY_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getProductionRegisterGrayFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REGISTER_GRAY_FILTER_REPORT_REQUEST });
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/production-register-report/filter-detail/gray?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_REGISTER_GRAY_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: PRODUCTION_REGISTER_GRAY_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: PRODUCTION_REGISTER_GRAY_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearProductionRegisterGrayReport = () => {
  return async (dispatch) => {
    dispatch({ type: PRODUCTION_REGISTER_GRAY_REPORT_SUCCESS, payload: {} });
  }
}
